import React from "react";
import { useContext, useEffect, useState } from "react";
import Entries from "../entries/myEntries";
import { Link, useNavigate,useLocation, matchPath } from "react-router-dom";
import $ from 'jquery';
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import SglContext from "../SglContext";
import md5 from "md5";
import liveclassimage from "../images/white-double-arrow.png";
import LiveClassWidget from "./liveClassWidget.js"

function SglSidebar(props) {
  const Sgl = useContext(SglContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [popup, setPop] = useState(false);
  const [rings_data, setRingsData] = useState([]);
  const [rings_keys, setRingsKeys] = useState([]);
  
  const [videoSwitches, setVideoSwitches] = useState({
    videos: true,
    videosOnDemand: true,
    videosLiveStream: true,
    specialEvents: true
  });

  useEffect(() => {
    if (Sgl.switches && Sgl.switches.switches) {
      const newSwitches = {
        videos: true,
        videosOnDemand: true,
        videosLiveStream: true,
        specialEvents: true
      };

      Sgl.switches.switches.forEach(element => {
        if (element.switch_name === 'Videos') {
          newSwitches.videos = element.value == 1;
        }
        if (element.switch_name === 'Videos on Demand') {
          newSwitches.videosOnDemand = element.value == 1;
        }
        if (element.switch_name === 'Videos - Live Ring Streams') {
          newSwitches.videosLiveStream = element.value == 1;
        }
        if (element.switch_name === 'Videos - Special Events Live Streaming') {
          newSwitches.specialEvents = element.value == 1;
        }
      });

      setVideoSwitches(newSwitches);
    }
  }, [Sgl.switches]);
  
  function closePopup() {
    setPop(false);
    var popup = document.getElementById("myPopup");
    popup.classList.remove("show");
    document.getElementById("live-classes-popup-overlay").style.display =
      "none";
  }
  function openPopup() {
    setPop(!popup);
    var popup = document.getElementById("myPopup");
    // popup.innerHTML = '<div className="popup-loader"></div>';
    // fetchLiveClassWidgetData();
    var liveClassBtn = document.getElementById("live-class-btn-desktop");
    if (liveClassBtn) {
      popup.style.top = liveClassBtn.offsetTop - 15 + "px";
    }
    popup.classList.toggle("show");
    document.getElementById("live-classes-popup-overlay").style.display =
      "block";
  }

  function active_menu() {   
    var url = window.location.href;
    $('.sgl-menu-item a').filter(function() {
        return this.href == url;
    }).addClass('selected_sgl_menu_item');
    $( ".selected_sgl_menu_item" ).parent( ".sgl-menu-item" ).parent( ".sgl-sub-menu" ).css( "display", "block" );
  }

  useEffect(() => {
    fetchLiveClassWidgetData();
    active_menu()
  }, [Sgl.exists_live_classes]);

  function fetchLiveClassWidgetData() {

        if (!Sgl.exists_live_classes) {
          var live_btn_desktop = document.getElementById(
            "live-class-btn-desktop"
          );
          var live_btn_mobile = document.getElementById("live-class-btn");
          if (live_btn_desktop) {
            live_btn_desktop.style.display = "none";
          }
          if (live_btn_mobile) {
            live_btn_mobile.style.setProperty("display", "none", "important");
          }
        } else {
          var live_btn_desktop = document.getElementById(
            "live-class-btn-desktop"
          );
          var live_btn_mobile = document.getElementById("live-class-btn");
          if (live_btn_desktop) {
            live_btn_desktop.classList.add("desktop-button-show");
          }
          if (live_btn_mobile) {
            live_btn_mobile.classList.add("mobile-button-show");
          }
        }
      // });
  }
  function closeDiv(){
    if(window.innerWidth<769){
      document.getElementById('sgl-sidebar').style.display="none";
    }
  }

  // Hide sidebar if URL contains /edit-account
  if (location.pathname.includes('/edit-account')) {
    return null;
  }

  return (
    <div className='sgl-col-3'>
      {
        props.sgl_mobile_menu == 1 && 
        <aside id='sgl-mobile-menu-btn' onClick={() => {$("#sgl-sidebar").slideToggle();}}>
          <span style={{ display: "flex" }}>
            <i className='fa fa-bars'></i>
            <h1 className='sgl-sgl-mobile-menu-toggle'>ShowGroundsLive</h1>
          </span>
        </aside>
      }

      {
        props.sgl_desktop_sidebar == 1 && 
        <div id='sgl-sidebar' className='sgl-sidebar' role='complementary'>
          {
            !props.hide_admin_functions &&
            <aside className='admin-function-btn'>
              <a
                target='_blank'
                href={Sgl.adminDomain + "/admin"}
                id='sgl-admin-menu-button'
                >
                Admin Functions
              </a>
            </aside>
          }

          <aside
            id='live-class-widget-section'
            className='live-class-widget-section'>
            <div className='live-btn-div'>
              <button
                className='live-class-btn'
                id='live-class-btn-desktop'
                onClick={openPopup}
                style={{ width: "fit-content", marginTop: "0px" }}>
                LIVE CLASSES
                <i
                  className='fa fa-chevron-right'
                  style={{
                    fontSize: "13px",
                    textAlign: "right",
                    verticalAlign: "middle",
                    width: "13px",
                    height: "15px",
                  }}></i>
              </button>
            </div>

            <div className='sgl-plugin-page sgl-plugin live-widget-parent-div'>
              <div id='live-classes-popup-overlay' onClick={closePopup}></div>
              <div className='popuptext ' id='myPopup'>
                {/* <div className='popup-loader'></div> */}
                {(popup) &&
                  <LiveClassWidget 
                    id='liveClassWidgetData'
                    closePopup={closePopup}
                    popup={popup}
                  />
                }
              </div>
              {/* <button
                className='live-class-btn'
                // className='live-class-btn mobile-button-show'
                id='live-class-btn'
                onClick={openPopup}>
                <img className='arrow-icon' src={liveclassimage} /> LIVE
              </button> */}
            </div>
          </aside>

          <aside id='sgl-left-nav-menu' className='sgl-left-nav-menu'>
            <div className='menu-sgl-menu-container'>
              <ul id='menu-left-sgl-menu' className='sgl-left-menu'>
                { 
                  props.company_id == 33 &&
                  <li class="menu-item menu-item-type-post_type menu-item-object-page menu-item-293" id="home_li">
                    <a class="fa fa-home" href="/showgroundslive">Home</a>
                  </li>
                }
                <li
                  id='actions_li'
                  className='sgl-menu-item sgl-menu-item-has-child sgl-first-menu-item'
                  aria-expanded='false'>
                  <a onClick={(e) => {
                    $(e.target.parentNode.querySelector(".sgl-sub-menu")).slideToggle();
                  }}>Actions</a>

                  <ul className='sgl-sub-menu'>
                    <li onClick={()=>closeDiv()} className="sgl-menu-item ">
                      <Link className= {`${matchPath("/add-entry", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/add-entry'>Add Entry</Link>
                    </li>
                    <li onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/class-adds-drops/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/class-adds-drops/'>Class Adds/Drops</Link>
                    </li>
                    <li onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/order-supplies/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/order-supplies/'>Order Supplies</Link>
                    </li>
                    <li onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/checkout-entries/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/checkout-entries/'>Checkout</Link>
                    </li>
                    <li onClick={()=>closeDiv()}  className='sgl-menu-item'>
                      <Link className= {`${matchPath("/orders-of-go-signups/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/orders-of-go-signups/'>
                        Orders of Go/Signups
                      </Link>
                    </li>
                    <li  onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/digital-signature/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/digital-signature/'>Digital Signature</Link>
                    </li>
                  </ul>
                </li>
                {
                  Sgl.exists_live_classes?
                  <li  onClick={()=>closeDiv()} className='sgl-menu-item liveclass-menu'>
                    <Link className= {`${matchPath("/liveclass/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/liveclass/'>Live Classes</Link>
                  </li>
                  :null
                }
                <li id='orderOfGo_li' onClick={()=>closeDiv()} className='sgl-menu-item'>
                  <Link className= {`${matchPath("/orders-of-go-signups/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/orders-of-go-signups/'>Orders of Go/Signups</Link>
                </li>
                <li
                  id='showResults_li'
                  className='sgl-menu-item sgl-menu-item-has-child'
                  aria-expanded='false'>
                  <a onClick={(e) => {
                    $(e.target.parentNode.querySelector(".sgl-sub-menu")).slideToggle();
                  }}>Show Results</a>

                  <ul className='sgl-sub-menu'>
                    <li className='sgl-menu-item'>
                      <Link  onClick={()=>closeDiv()} className= {`${matchPath("/browse", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/browse'>Browse</Link>
                    </li>
                    <li  onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/daily-results/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/daily-results/'>Daily Results</Link>
                    </li>
                    <li  onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/show-champions/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/show-champions/'>Show Champions</Link>
                    </li>
                    <li  onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/circuit-standings/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/circuit-standings/'>Circuit Standings</Link>
                    </li>
                  </ul>
                </li>
                <li id='myResults_li' onClick={()=>closeDiv()} className='sgl-menu-item'>
                  <Link className= {`${matchPath("/my-results/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/my-results/'>My Results</Link>
                </li>
                <li id='classes_li' onClick={()=>closeDiv()} className='sgl-menu-item'>
                  <Link className= {`${matchPath("/classes", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/classes'>Classes</Link>
                </li>
                <li id='people_li' onClick={()=>closeDiv()} className='sgl-menu-item'>
                  <Link className= {`${matchPath("/people", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/people'>People</Link>
                </li>
                <li id='entries_li' onClick={()=>closeDiv()} className='sgl-menu-item'>
                  <Link className= {`${matchPath("/horses-entries/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/horses-entries/'>Horses (Entries)</Link>
                </li>
                <li onClick={()=>closeDiv()} className='sgl-menu-item' id='my-entries-menu-item'>
                  <Link className= {`${matchPath("/my-entries/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/my-entries/'>My Entries</Link>
                </li>
                <li
                  id='schedule_li'
                  className='sgl-menu-item sgl-menu-item-has-child'
                  aria-expanded='false'>
                  <a onClick={(e) => {
                    $(e.target.parentNode.querySelector(".sgl-sub-menu")).slideToggle();
                  }}>Schedule</a>

                  <ul className='sgl-sub-menu'>
                    <li onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/show-schedule/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/show-schedule/'>Show Schedule</Link>
                    </li>
                    <li onClick={()=>closeDiv()} className='sgl-menu-item'>
                      <Link className= {`${matchPath("/my-schedule/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/my-schedule/'>My Schedule</Link>
                    </li>
                  </ul>
                </li>
                <li id='ringStatus_li' onClick={()=>closeDiv()} className='sgl-menu-item'>
                  <Link className= {`${matchPath("/ring-status/", location.pathname) ? "selected_sgl_menu_item" : ""}`} to='/ring-status/'>Ring Status</Link>
                </li>
              {(videoSwitches.videos || videoSwitches.videosLiveStream || 
              videoSwitches.videosOnDemand || videoSwitches.specialEvents) && (
                <li
                  id='videos_li'
                  className='sgl-menu-item sgl-menu-item-has-child'
                  aria-expanded='false'>
                  <a onClick={(e) => {
                    $(e.target.parentNode.querySelector(".sgl-sub-menu")).slideToggle();
                  }}>Videos</a>

                  <ul className='sgl-sub-menu'>
                    {videoSwitches.videosLiveStream && props.company_id != 15 && (
                      <li onClick={closeDiv} className='sgl-menu-item'>
                        {props.company_id == 245 ? (
                          <a 
                            href='/livestream-2025'
                            className={location.pathname === "/livestream-2025/" || location.pathname === "/livestream-2025" ? "selected_sgl_menu_item" : ""}>
                            Live Ring Streams
                          </a>
                        ) : (
                          <Link
                            to='/live-channels'
                            className={matchPath("/live-channels/", location.pathname) ? "selected_sgl_menu_item" : ""}>
                            Live Ring Streams
                          </Link>
                        )}
                      </li>
                    )}
                    
                    {/* {videoSwitches.videosOnDemand && props.company_id != 15 && (
                      <li onClick={closeDiv} className='sgl-menu-item'>
                        <Link className={`${matchPath("/demand-channels/", location.pathname) ? "selected_sgl_menu_item" : ""}`} 
                              to='/demand-channels/'>Videos On Demand</Link>
                      </li>
                    )} */}
                    
                    {videoSwitches.specialEvents && props.company_id != 15 && (
                      <li onClick={closeDiv} className='sgl-menu-item'>
                        <Link to='/special-events-live-streaming' className= {`${matchPath("/special-events-live-streaming/", location.pathname) ? "selected_sgl_menu_item" : ""}`}>Special Events - Live Streaming</Link>
                      </li>
                    )}
                    
                    {videoSwitches.videos && (
                      <li onClick={closeDiv} className='sgl-menu-item'>
                        <Link className={`${matchPath("/videos/", location.pathname) ? "selected_sgl_menu_item" : ""}`} 
                              to="/videos/">Videos</Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {/* Terms of Service - Mobile Only */}
              <li onClick={()=>closeDiv()} className='sgl-menu-item mobile-only-tos'>
                <Link 
                  className={`${matchPath("/terms-of-service/", location.pathname) ? "selected_sgl_menu_item" : ""}`} 
                  to='/terms-of-service/'>
                  Terms of Service
                </Link>
              </li>
              </ul>
            </div>
          </aside>
          <aside className='my-entries-widget'>
            <div className='my-entries-section'>
              <div id='my-entries-box'>
                <Entries
                  current_show={props.currentShow}
                  current_user={Sgl.current_user}
                />
              </div>
            </div>
          </aside>
        </div>
      }
    </div>
  );
}

export default SglSidebar;